import { Alert,AlertTitle } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';




export default function ErrorAlert ({ setErrorBusinnesDetails,setErrorDetailsPackage }) {


const handelOnFocus =()=>{
    setErrorBusinnesDetails &&   setErrorBusinnesDetails(false);
    setErrorDetailsPackage &&   setErrorDetailsPackage(false);
}
    return (
        <div style={{display:"flex",justifyContent:"center"}}>
        <Alert
            sx={{ "& MuiAlert-icon": { marginLeft: "6px", padding: "0",marginBottom:"36px" } }}
            action={
                <IconButton
                    aria-label="close"
                    color="inherit"
                    size="small"
                    onClick={() => {
                        handelOnFocus()
                    }}
                >
                    <CloseIcon fontSize="inherit" />
                </IconButton>
            }
            style={{ direction: "rtl", position: "absolute", zIndex: 1000,top:"50%",width: '330px',
            height: '123px',
            background: 'azure',
            display: 'flex',
            flexDirection: 'row-reverse' }}
            severity="error">
            <AlertTitle>שגיאה</AlertTitle>
            <strong>חסרים פרטים או שהוזנו פרטים שגויים</strong>
        </Alert>
</div>
    )
}